<template>
  <app-layout>
    <app-header>
      <icon-link
        :href="route('home')"
        icon="arrow-thin-left-circle"
        class="icon-secondary"
      >
        Back to dashboard
      </icon-link>
      <h1>My Applications</h1>

      <!-- <template v-slot:navigation>
        <ul>
          <li>
            <a href="#" class="is-active">All applications</a>
          </li>
          <li>
            <a href="#">Approved</a>
          </li>
          <li>
            <a href="#">Rejected</a>
          </li>
          <li>
            <a href="#">Submitted</a>
          </li>
          <li>
            <a href="#">Draft</a>
          </li>
        </ul>
      </template> -->
    </app-header>

    <div>
      <div class="container">
        <ul class="list-reset flex flex-wrap -mx-4">
          <li
            v-for="application in applications"
            :key="'application_' + application.uuid"
            class="w-full lg:w-1/3 lg:flex p-4"
          >
            <user-application-card :application="application" />
          </li>
          <li
            v-for="filler in [1, 2, 3].slice(applications.length, 3)"
            :key="filler"
            class="hidden lg:w-1/3 lg:flex p-4"
            style="min-height: 13rem"
          >
            <div class="w-full border-dashed border border-grey-300" />
          </li>
        </ul>
      </div>
    </div>
  </app-layout>
</template>

<script>
export default {
  name: "Applications",
  computed: {
    applications() {
      return this.state.applications;
    },
  },
  created() {
    document.title = `Applications Archive :: ${document.title}`;
  }
};
</script>
